export default "__VITE_ASSET__2f18b91f__"